<template>
  <sdPageHeader :title="title"> </sdPageHeader>
  <Main>
    <HorizontalFormStyleWrap>
      <sdCards headless>
        <a-form
          layout="horizontal"
          :model="formState"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          labelAlign="left"
          :rules="rules"
          @finish="handleSubmit"
        >
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item name="kpi_korporat_id" label="Nama KPI">
                <a-select
                  placeholder="Pilih KPI"
                  v-model:value="formState.kpi_korporat_id"
                  show-search
                  :filter-option="filterSelect"
                  @change="changeKpiKorporat"
                  :disabled="mode == 'Ubah' ? true : false"
                  v-if="mode == 'Ubah' || mode == 'Tambah' || mode == 'Verifikasi' || mode == 'Edit'"
                >
                  <a-select-option v-for="option in options.kpiKorporat" :key="option.value">
                    {{ option.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item name="month" label="Bulan">
                <a-select
                  placeholder="Pilih Bulan"
                  v-model:value="formState.month"
                  show-search
                  :filter-option="filterSelect"
                  :disabled="mode == 'Ubah' ? true : false"
                  v-if="mode == 'Ubah' || mode == 'Tambah' || mode == 'Verifikasi' || mode == 'Edit'"
                >
                  <a-select-option v-for="option in options.month2" :key="option.value">
                    {{ option.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item name="target" label="Target KM">
                <a-input disabled v-model:value="detailState.target" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item name="target_bulanan" label="Target Bulanan">
                <a-input disabled v-model:value="detailState.targetBulanan" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item name="bobot" label="Bobot">
                <a-input disabled v-model:value="detailState.bobot" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item name="polarisasi" label="Polarisasi">
                <a-input disabled v-model:value="detailState.polaritas" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item
                v-if="jenisVariableKpi == 3"
                name="nilai"
                label="Nilai Pengurangan"
                :rules="[{ required: true, message: 'Harap masukkan nilai pengurangan' }]"
              >
                <a-input-group compact>
                  <a-input style="width: 50px; text-align: center;" value="-" disabled />
                  <a-input-number
                    v-model:value="formState.nilai"
                    style="width: calc(100% - 50px)"
                    placeholder="Masukkan Nilai Pengurangan"
                    controls="false"
                  />
                </a-input-group>
              </a-form-item>
              <a-form-item
                v-if="jenisVariableKpi == 1"
                name="realisasi_nominal"
                label="Realisasi Nominal"
                :rules="[{ required: true, message: 'Harap masukkan realisasi nominal' }]"
              >
                <a-input-number v-model:value="formState.realisasi_nominal" placeholder="Masukkan Realisasi Nominal" />
              </a-form-item>
              <a-form-item
                v-if="jenisVariableKpi == 2"
                name="realisasi_waktu"
                label="Realisasi Waktu"
                :rules="[{ required: true, message: 'Harap masukkan realisasi waktu' }]"
              >
                <a-month-picker
                  v-model:value="formState.realisasi_waktu"
                  placeholder="Pilih Bulan"
                  format="MM-YYYY"
                  valueFormat="YYYY-MM-DD"
                />
              </a-form-item>
              <a-form-item
                v-if="jenisVariableKpi == 4"
                name="realisasi_manual"
                label="Realisasi Manual"
                :rules="[{ required: true, message: 'Harap masukkan realisasi manual' }]"
              >
                <a-textarea
                  v-model:value="formState.realisasi_manual"
                  :auto-size="{ minRows: 3, maxRows: 6 }"
                  placeholder="Masukkan Realisasi Manual"
                />
              </a-form-item>
              <a-form-item
                v-if="jenisVariableKpi == 4"
                name="pencapaian"
                label="Pencapaian"
                :rules="[{ required: true, message: 'Harap masukkan pencapaian' }]"
              >
                <a-input-number v-model:value="formState.pencapaian" placeholder="Masukkan Pencapaian" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item name="satuan" label="Satuan">
                <a-input-number disabled v-model:value="detailState.satuan" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <div v-if="mode != 'Verifikasi' && mode != 'Edit'">
                <a-form-item
                  name="penjelasan"
                  label="Penjelasan Tercapai/Tidak Tercapai"
                  :rules="[{ required: true, message: 'Harap masukkan penjelasan tercapai/tidak tercapai' }]"
                >
                  <a-textarea
                    v-model:value="formState.penjelasan"
                    :auto-size="{ minRows: 3, maxRows: 6 }"
                    placeholder="Masukkan Penjelasan Tercapai/Tidak Tercapai"
                  />
                </a-form-item>
                <a-form-item
                  name="action_plan"
                  label="Action Plan"
                  :rules="[{ required: true, message: 'Harap masukkan action plan' }]"
                >
                  <a-textarea
                    v-model:value="formState.action_plan"
                    :auto-size="{ minRows: 3, maxRows: 6 }"
                    placeholder="Masukkan Action Plan"
                  />
                </a-form-item>
              </div>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :span="24">
              <div
                class="sDash_form-action"
                style="text-align: right;"
                v-if="mode == 'Ubah' || mode == 'Tambah' || mode == 'Verifikasi' || mode == 'Edit'"
              >
                <sdButton class="sDash_form-action__btn" type="primary" size="large" htmlType="submit">
                  {{ isLoading ? 'Harap Menunggu...' : mode }}
                </sdButton>

                <router-link v-if="mode == 'Tambah'" :to="'/nko/rekap/'">
                  <sdButton class="sDash_form-action__btn" type="light" size="large" htmlType="button">
                    Batal
                  </sdButton>
                </router-link>

                <router-link v-else :to="'/nko/rekap/'">
                  <sdButton class="sDash_form-action__btn" type="light" size="large" htmlType="button">
                    Batal
                  </sdButton>
                </router-link>
              </div>
              <div class="sDash_form-action" style="text-align: right;" v-else>
                <router-link :to="'/nko/rekap/'">
                  <sdButton class="sDash_form-action__btn" type="light" size="large" htmlType="button">
                    Kembali
                  </sdButton>
                </router-link>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </sdCards>
    </HorizontalFormStyleWrap>
  </Main>
</template>

<script>
import { HorizontalFormStyleWrap } from '../../../components/crud/style';
import { Main } from '../../styled';
import { useStore } from 'vuex';
import { reactive, computed, onMounted, toRaw, ref } from 'vue';
import { useRoute } from 'vue-router';
import { getItem } from '@/utility/localStorageControl';
import axiosApi from '@/api';

const RealisasiKpiKorporatForm = {
  name: 'RealisasiKpiKorporatForm',
  components: { HorizontalFormStyleWrap, Main },
  data() {
    return {
      title: this.mode + ' ' + this.module,
    };
  },
  props: ['mode', 'module'],
  setup(props) {
    const { state, dispatch } = useStore();
    const { params } = useRoute();
    const isLoading = computed(() => state.crud.loading);
    const crud = computed(() => state.crud.data);
    const profile = getItem('profile_plnbb');
    const accessToken = getItem('access_token');
    const permissions = getItem('permissions');
    const formState = reactive({
      kpi_korporat_id: undefined,
      realisasi_nominal: undefined,
      realisasi_waktu: undefined,
      realisasi_manual: undefined,
      pencapaian: undefined,
      nilai: undefined,
      month: params.month,
      realisasis: [],
      name: '',
      monthName: '',
      statusKpi: null,
      penjelasan: '',
      action_plan: '',
    });
    const detailState = reactive({
      target: '',
      targetBulanan: '',
      bobot: '',
      pencapaian: '',
      nilai: '',
      satuan: '',
      polaritas: '',
    });

    const jenisVariableKpi = ref('');

    const modalState = reactive({
      isLoading: false,
      visible: false,
      kpi_korporat: '',
      month: '',
      year: null,
      type: '',
    });

    const formModalState = reactive({
      id: null,
      alasan: '',
    });

    const dateState = reactive({
      month: params.month,
      year: params.year,
    });

    const options = reactive({
      kpiKorporat: [],
      month: [
        { value: 1, text: 'Januari' },
        { value: 2, text: 's.d. Februari' },
        { value: 3, text: 's.d. Maret' },
        { value: 4, text: 's.d. April' },
        { value: 5, text: 's.d. Mei' },
        { value: 6, text: 's.d. Juni' },
        { value: 7, text: 's.d. Juli' },
        { value: 8, text: 's.d. Agustus' },
        { value: 9, text: 's.d. September' },
        { value: 10, text: 's.d. Oktober' },
        { value: 11, text: 's.d. November' },
        { value: 12, text: 's.d. Desember' },
      ],
      month2: [
        { value: 1, text: 'Januari' },
        { value: 2, text: 'Februari' },
        { value: 3, text: 'Maret' },
        { value: 4, text: 'April' },
        { value: 5, text: 'Mei' },
        { value: 6, text: 'Juni' },
        { value: 7, text: 'Juli' },
        { value: 8, text: 'Agustus' },
        { value: 9, text: 'September' },
        { value: 10, text: 'Oktober' },
        { value: 11, text: 'November' },
        { value: 12, text: 'Desember' },
      ],
    });

    const variableKpiKorporats = reactive({
      is_akumulasi: false,
      data: {},
    });

    const labelCol = {
      lg: 6,
      md: 9,
      xs: 24,
    };

    const wrapperCol = {
      lg: 18,
      md: 15,
      xs: 24,
    };

    const handleSubmit = () => {
      const postData = toRaw(formState);

      if (jenisVariableKpi.value == 2) {
        postData.realisasis.forEach((realisasi, key) => {
          let my = realisasi.split('-');
          postData.realisasis[key] = my[0] + '-' + my[1] + '-' + '01';
        });
      }

      if (props.mode == 'Tambah') {
        dispatch('axiosCrudSubmitDataRedirect', {
          url: 'realisasi-nko',
          data: postData,
          redirect: '/nko/rekap/',
        });
      } else if (props.mode == 'Ubah') {
        dispatch('axiosDataUpdateRedirect', {
          id: params.id,
          url: 'realisasi-nko',
          data: postData,
          redirect: '/nko/rekap/',
        });
      } else if (props.mode == 'Verifikasi') {
        dispatch('axiosCrudSubmitDataRedirect', {
          url: 'verifikasi-realisasi-kpi',
          data: postData,
          redirect: '/nko/rekap/',
        });
      } else if (props.mode == 'Edit') {
        dispatch('axiosDataUpdateRedirect', {
          id: params.id,
          url: 'verifikasi-realisasi-kpi',
          data: postData,
          redirect: '/nko/rekap/',
        });
      }
    };

    const rules = {
      kpi_korporat_id: [
        {
          required: true,
          message: 'Harap Dipilih',
          trigger: 'blur',
          type: 'number',
        },
      ],
      month: [
        {
          required: true,
          message: 'Harap Dipilih',
          trigger: 'blur',
          type: 'number',
        },
      ],
    };

    const filterSelect = (input, option) => {
      return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    const changeKpiKorporat = value => {
      dispatch('axiosCrudGetData', 'variable-kpi-korporats-by-kpi-korporat?kpi_korporat_id=' + value).then(() => {
        variableKpiKorporats.data = crud.value.data;
        variableKpiKorporats.is_akumulasi = crud.value.data[0].kpi_korporat.is_akumulasi;
      });
    };

    const changeJenisVariableKpi = value => {
      axiosApi.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;

      axiosApi
        .get('kpi-korporat/' + value, {
          params: {
            month: params.month,
          },
        })
        .then(response => {
          jenisVariableKpi.value = response.data.data.jenis_variable_kpi_id;
          detailState.target = response.data.data.target_km;
          detailState.targetBulanan = response.data.data.target_bulanan;
          detailState.polaritas = response.data.data.polarisasi;
          detailState.bobot = response.data.data.bobot;
          detailState.satuan = response.data.data.satuan_kpi.name;
        });
    };

    onMounted(() => {
      getData();
    });

    const getData = () => {
      dispatch('axiosCrudGetData', 'options-kpi-korporat').then(() => {
        options.kpiKorporat = crud.value;

        if (props.mode == 'Tambah' || props.mode == 'Verifikasi') {
          formState.kpi_korporat_id = parseInt(params.id);
          formState.month = parseInt(params.month);

          // changeKpiKorporat(parseInt(params.id));
          changeJenisVariableKpi(parseInt(params.id));
        }
      });

      if (props.mode == 'Ubah' || props.mode == 'Edit') {
        let data = {
          url: '',
          id: '',
        };
        if (props.mode == 'Ubah') {
          data = {
            url: 'realisasi-nko',
            id: params.id,
          };
        } else if (props.mode == 'Edit') {
          data = {
            url: 'verifikasi-realisasi-kpi',
            id: params.id,
          };
        }
        dispatch('axiosSingleDataGet', data).then(() => {
          Object.keys(crud.value).forEach(key => {
            formState[key] = crud.value[key];
          });

          formState.name = crud.value.kpi_korporat.name;
          formState.year = crud.value.kpi_korporat.year;
          formState.statusKpi = crud.value.status;
          formState.realisasi_nominal = crud.value.realisasi_nominal;
          formState.realisasi_waktu = crud.value.realisasi_waktu;
          formState.realisasi_manual = crud.value.realisasi_manual;
          detailState.target = crud.value.target_km;
          detailState.targetBulanan = crud.value.target_bulanan;
          detailState.polaritas = crud.value.kpi_korporat.polarisasi;
          detailState.bobot = crud.value.kpi_korporat.bobot;
          detailState.satuan = crud.value.kpi_korporat.satuan_kpi.name;

          jenisVariableKpi.value = crud.value.kpi_korporat.jenis_variable_kpi_id;
          // // formState.alasan = crud.value.last_alasan;

          if (!crud.value.kpi_korporat.is_akumulasi) {
            // formState.monthName = options.month[crud.value.month].text;
            formState.monthName = options.month.find(month => month.value === crud.value.month).text;
          } else {
            // formState.monthName = options.month2[crud.value.month].text;
            formState.monthName = options.month2.find(month => month.value === crud.value.month).text;
          }
        });
      }
    };

    const checkPermission = permission => {
      if (profile.roles[0].name == 'Super Admin') {
        return true;
      }

      if (Array.isArray(permission)) {
        return permission.some(p => permissions.includes(p.toLowerCase()));
      }

      return permissions.includes(permission.toLowerCase());
    };

    const modalRules = {
      alasan: [
        {
          required: true,
          message: 'Harap Diisi',
          trigger: 'blur',
        },
      ],
    };

    return {
      formState,
      detailState,
      labelCol,
      wrapperCol,
      handleSubmit,
      isLoading,
      rules,
      options,
      filterSelect,
      changeKpiKorporat,
      variableKpiKorporats,
      dateState,
      formModalState,
      modalState,
      modalRules,
      checkPermission,
      jenisVariableKpi,
      changeJenisVariableKpi,
    };
  },
};

export default RealisasiKpiKorporatForm;
</script>
